import { render, staticRenderFns } from "./FiltersModule.vue?vue&type=template&id=72772b6d&scoped=true&"
import script from "./FiltersModule.vue?vue&type=script&lang=js&"
export * from "./FiltersModule.vue?vue&type=script&lang=js&"
import style0 from "./FiltersModule.vue?vue&type=style&index=0&id=72772b6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72772b6d",
  null
  
)

export default component.exports